import { Box, Flex } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './AskSiestaInput.module.css';

type Props = {
  variant?: 'light' | 'brand';
  onSubmit?: (message: string) => void;
  onFocus?: () => void;
};

export function AskSiestaInput({ variant = 'light', onSubmit, onFocus }: Props) {
  const [value, setValue] = useState('');
  const borderColor = variant === 'light' ? 'orange-1' : 'orange-6';
  const colorVar = `var(--mantine-color-${borderColor})`;

  const handleSubmit = () => {
    if (value.trim() && onSubmit) {
      onSubmit(value.trim());
      setValue('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Box
      px="lg"
      h={52}
      w="100%"
      style={{
        borderRadius: 'var(--mantine-radius-xl)',
        border: `4px solid ${colorVar}`,
        background: 'transparent',
      }}
    >
      <Flex align="center" h="100%" gap="xs">
        <input
          type="text"
          placeholder="Ask me anything"
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={onFocus}
          className={classes.input}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: colorVar,
            fontSize: 'var(--mantine-font-size-textMd)',
            fontWeight: FONT_WEIGHTS.medium,
            fontFamily: 'inherit',
          }}
        />
        <IconPlus
          size={24}
          color={colorVar}
          style={{ cursor: value.trim() ? 'pointer' : 'default' }}
          onClick={handleSubmit}
        />
      </Flex>
    </Box>
  );
}
